import React, { useContext } from 'react';
import { UserContext } from './App';
import { useNavigate } from 'react-router-dom';


import { loginPath } from "../src/services/apiConfig";

import { useState } from 'react';

function Login() {
  const navigate = useNavigate();
  const [passwd, setPWD] = useState("");
  const [userid, setUID] = useState("");
  let token = "";
  let role = "";
  let roleName = "";
  const [error, setError] = useState('');
//  const [display, setDisplay] = useState('none');
//  const [oldPw, setOldPw] = useState('')
//  const [newPw, setNewPw] = useState('')
  const [cnfPw, setCnfPw] = useState('')
  const { state, dispatch } = useContext(UserContext);

  async function handleChangeSubmit() {

    let result = await fetch(loginPath + "signin", {

      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },

      body: JSON.stringify({ "email": userid, "password": passwd })
    });
    result = await result.json();

    if (result.success === false) {
      setError(result.message + ": " + JSON.stringify(result.data))
    } else {
      token = result.data.authToken;
      // userid = result.data.userId;
      roleName = result.data.roleName;
      setUID(result.data.userEmail);
      localStorage.setItem('user-info', result.data.userName);
      localStorage.setItem('token', token);
      localStorage.setItem('user-role', roleName)
      localStorage.setItem('LoginId', result.data.userId)

      dispatch({ type: 'USER', payload: true })
      navigate('/User');
      setError(result.message)
    }
 }

  function handleChangeUid(e) {
    setUID(e.target.value)
    setError('')
  }

  function handleChangePwd(e) {
    setPWD(e.target.value)
    setError('')
  }

  return (
    <>
      <div className="row p32" style={{ 'height': '90%' }}>
        <div className="container flex" style={{
          'height': '70%',
          'width': '60%',
          'margin': '6%',
          'marginLeft': '20%'
        }}>

          <div className='signin-form'>
            <h2 className='form-title' >Sign in</h2>
            <div className='form-group'>
              <img style={{ 'height': '5%', 'width': '15%', 'marginTop': '2%' }} src={require('./asset/images/adm_usr2.png')} alt="" />
              <input type='text' name='uid' id='uid' autoComplete='off'
                placeholder='User Id' onChange={handleChangeUid}
                value={userid} />
            </div>

            <div className='form-group'>
              <img style={{ 'height': '5%', 'width': '15%', 'marginTop': '2%' }} src={require('./asset/images/adm_lock2.png')} alt="" />
              <input type='password' name='password' id='password' autoComplete='off'
                placeholder='password' onChange={handleChangePwd}
                value={passwd} />
            </div>

            <div>
              <button type="button" className="btn solid round" onClick={handleChangeSubmit}>Login</button>
            </div>
            <label>{error}</label>
          </div>

          <div classname="login-image" style={{
            'height': '100px',
            'width': '400px', 'marginTop': '30px', 'marginLeft': '70px'
          }}>

            <img alt="" src={require('./asset/images/LoginImage2.jpg')} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Login
